class bewertungReviewCard extends HTMLElement {
  connectedCallback() {
    this.setElements();
    this.bindEvents();
    this.beobachteTextUeberlauf();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  setElements() {
    this.weiterlesenButton = this.querySelector('.button-weiterlesen');
    this.reviewCard = this.querySelector('.review-card');
    this.bewertungText = this.querySelector('.bewertung-text');
  }

  bindEvents() {
    // RED-12573: Card kennt ihren Kontext nicht – sie meldet nur den Klick samt ID nach oben
    this.weiterlesenButton?.addEventListener('click', () =>
      this.dispatchEvent(
        new CustomEvent('bewertung-weiterlesen', {
          bubbles: true,
          detail: { bewertungId: this.dataset.bewertungId },
        }),
      ),
    );
  }

  // RED-12573: Vom Eltern-Kontext aufgerufen – klappt den vollständigen Text aus (CSS blendet den Button aus).
  // Klasse muss auf den inneren Container: der thalia-cli-Build prefixt jeden Selektor mit dem Host-Namen
  // (.text-vollstaendig → bewertung-review-card .text-vollstaendig ...), greift also nur auf einem Nachfahren.
  zeigeVollstaendigenText() {
    this.reviewCard?.classList.add('text-vollstaendig');
  }

  // RED-12573: ResizeObserver feuert initial und bei jeder Größenänderung (auch beim Öffnen des Overlays)
  beobachteTextUeberlauf() {
    if (!this.bewertungText) return;
    this.resizeObserver = new ResizeObserver(() => this.pruefeTextUeberlauf());
    this.resizeObserver.observe(this.bewertungText);
  }

  pruefeTextUeberlauf() {
    if (this.reviewCard?.classList.contains('text-vollstaendig')) return;
    const gekuerzt = this.bewertungText.scrollHeight > this.bewertungText.clientHeight + 1;
    this.reviewCard?.classList.toggle('text-passt', !gekuerzt);
  }
}

if (!customElements.get("bewertung-review-card")) {
  customElements.define("bewertung-review-card", bewertungReviewCard);
}
